import { CardSection, CardHeader } from '@europrocurement/flexy-components';
import * as React from 'react';
import { PrescriberTabProps } from './types';

const Offers: React.FunctionComponent<PrescriberTabProps> = function () {
    const cardHeader = (
        <CardHeader
            title="Offres"
            border={false}
        />
    );
    return <CardSection header={cardHeader}>content</CardSection>;
};

export default Offers;
